import { ListOptions } from "./interfaces/list-options";
import i18n from "../i18n";

export default class UserRoles {
    public static ADMIN_ID = "admin";
    public static GROUP_MANAGER_ID = "group_manager";
    public static TEAM_MEMBER_ID = "team_member";
    public static ACCOUNT_HOLDER_ID = "account_holder";
    public static CLIENT_ID = "client";

    /**
     * All role options. Sort in the display order (not alphabetical).
     */
    public static ALL_ROLES: ListOptions[] = [
        {
            value: UserRoles.TEAM_MEMBER_ID,
            label: i18n.t('roles.teamMember'),
        },
        {
            value: UserRoles.GROUP_MANAGER_ID,
            label: i18n.t('roles.groupManager'),
        },
        {
            value: UserRoles.ADMIN_ID,
            label: i18n.t('roles.admin'),
        },
        {
            value: UserRoles.ACCOUNT_HOLDER_ID,
            label: i18n.t('roles.accountHolder'),
        },
        {
            value: UserRoles.CLIENT_ID,
            label: i18n.t('roles.user'),
        },
    ];

    /**
     * Role options for managers.
     */
    public static MANAGER_ROLES: ListOptions[] = [
        {
            value: UserRoles.TEAM_MEMBER_ID,
            label: i18n.t('roles.teamMember'),
        },
        {
            value: UserRoles.CLIENT_ID,
            label: i18n.t('roles.user'),
        },
    ];

    public static MANAGER_ROLES_ADDING_USERS: ListOptions[] = [
        {
            value: UserRoles.TEAM_MEMBER_ID,
            label: i18n.t('roles.teamMember'),
        },
        {
            value: UserRoles.GROUP_MANAGER_ID,
            label: i18n.t('roles.groupManager'),
        },
        // {
        //     value: UserRoles.CLIENT_ID,
        //     label: "User",
        // },
    ]

    public static ADMIN_ROLES: ListOptions[] = [
        {
            value: UserRoles.TEAM_MEMBER_ID,
            label: i18n.t('roles.teamMember'),
        },
        {
            value: UserRoles.GROUP_MANAGER_ID,
            label: i18n.t('roles.groupManager'),
        },
        {
            value: UserRoles.ADMIN_ID,
            label: i18n.t('roles.admin'),
        },
        {
            value: UserRoles.CLIENT_ID,
            label: i18n.t('roles.user'),
        },
    ];

    public static ADMIN_ROLES_ADDING_USERS: ListOptions[] = [
        {
            value: UserRoles.TEAM_MEMBER_ID,
            label: i18n.t('roles.teamMember'),
        },
        {
            value: UserRoles.GROUP_MANAGER_ID,
            label: i18n.t('roles.groupManager'),
        },
        {
            value: UserRoles.ADMIN_ID,
            label: i18n.t('roles.admin'),
        },
    ];
}
